export default __webpack_public_path__ + "static/sierraoutdoors-79f4d8c0b8555668b62295dd9fb5dccf.png";